<template>
  <div>
    <v-dialog
      v-model="visible"
      @click:outside.stop="closeDialogOutside"
      max-width="290"
    >
      <v-card style="margin: 0 !important">
        <v-card-title class="text-h6 justify-content-center mb-3">
          <slot name="header"></slot>
        </v-card-title>

        <v-card-text>
          <v-text-field
            v-model="value"
            :label="entity || 'E.g. https://domain.com'"
            :rules="[rules.required]"
            :loading="loading"
            required
            solo
          ></v-text-field>
          <slot name="text"></slot>
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="blue darken-2"
            text
            :disabled="loading"
            @click.stop="closeDialogOutside"
          >
            <slot name="disagreeBtnText"></slot>
          </v-btn>

          <v-btn
            color="blue darken-2"
            text
            :loading="loading"
            @click.stop="handleEmitToConfirmBtn"
          >
            <slot name="agreeBtnText"></slot>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: "DialogWindow",
  props: {
    entity: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      visible: true,
      value: this.entity || "",
      error: "",
      rules: {
        required: (value) => !!value || "Required.",
      },
    };
  },
  methods: {
    handleEmitToConfirmBtn() {
      this.$emit("confirmed", this.value);
    },
    closeDialogOutside() {
      setTimeout(() => {
        this.$emit("closeDialogOutside");
      }, 70);

      this.visible = false;
    },
  },
};
</script>

<style>
input[type="checkbox"] {
  height: 12px;
  width: 12px;
  margin: 6px;
}
button.v-icon {
  color: #c6c6c6 !important;
}
.lgImage {
  width: 100%;
  height: 200px;
  background-size: cover;
  background-position: center;
}
</style>
